import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../store/slices/authSlice";

export default function useTrackVisit() {
  const location = useLocation();
  const user = useSelector(selectUser);
  const lastTracked = useRef(null);

  useEffect(() => {
    const page = location.pathname;
    const key = `${page}|${user?.id ?? "anon"}`;
    if (lastTracked.current === key) return;
    lastTracked.current = key;

    // Fire-and-forget — never block the UI
    fetch(`${process.env.REACT_APP_API_URL}/track/visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ page, userId: user?.id ?? null }),
    }).catch(() => {});
  }, [location.pathname, user?.id]);
}
